export type {
  ToastTitleBaseProps as ToastTitleProps,
  ToastTitleBaseState as ToastTitleState,
  ToastTitleSlots,
} from '@fluentui/react-toast';
